var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { resolveMediaUrl } from '@/shared/api/csio/media';
var HERO_BANNER_SLUG = 'glavnyy-baner';
var CONSULTATION_BANNER_SLUG = 'baner-konsultatsiya';
var SLUG_TO_KIND = {
    'nashi-kursy': 'courses',
    'dlya-kogo': 'motives',
    'format-obucheniya': 'format',
    otzyvy: 'feedback',
    prepodovateli: 'teachers',
    'vopros-otvet': 'questions',
};
var asString = function (value) {
    if (value == null)
        return '';
    if (typeof value === 'string' || typeof value === 'number')
        return String(value);
    return '';
};
var field = function (item, key) { var _a, _b, _c, _d; return (_b = (_a = item.fields) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : (_d = (_c = item.values) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.value; };
var collectionItems = function (block) {
    if (!block || block.kind !== 'collection')
        return [];
    return Array.isArray(block.items) ? block.items : [];
};
var singletonFields = function (block) {
    var _a;
    if (!block || block.kind !== 'singleton')
        return {};
    return ((_a = block.item) === null || _a === void 0 ? void 0 : _a.fields) || {};
};
var entityValue = function (block, key) {
    var _a, _b, _c;
    var fromEntity = (_a = block.entity) === null || _a === void 0 ? void 0 : _a[key];
    if (fromEntity != null && fromEntity !== '') {
        return asString(fromEntity);
    }
    var fromValues = (_c = (_b = block.entityValues) === null || _b === void 0 ? void 0 : _b[key]) === null || _c === void 0 ? void 0 : _c.value;
    return asString(fromValues);
};
var normalizeLabel = function (label) {
    return label
        .trim()
        .toLowerCase()
        .replace(/ё/g, 'е');
};
/** Заголовок секции: entity-поле «Заголовок» / ключи zagolovok*, иначе label сущности */
var sectionTitle = function (block) {
    var values = block.entityValues || {};
    for (var _i = 0, _a = Object.values(values); _i < _a.length; _i++) {
        var meta = _a[_i];
        var label = normalizeLabel(meta.label || '');
        if (label === 'заголовок' || (label.includes('заголовок') && !label.includes('под'))) {
            var value = asString(meta.value);
            if (value)
                return value;
        }
    }
    for (var _b = 0, _c = Object.keys(block.entity || {}); _b < _c.length; _b++) {
        var key = _c[_b];
        if (/^zagolovok(_\d+)?$/i.test(key)) {
            var value = entityValue(block, key);
            if (value)
                return value;
        }
    }
    return asString(block.label);
};
/** Подзаголовок: entity-поле «Подзаголовок» / podzagolovok */
var sectionSubtitle = function (block) {
    var values = block.entityValues || {};
    for (var _i = 0, _a = Object.values(values); _i < _a.length; _i++) {
        var meta = _a[_i];
        var label = normalizeLabel(meta.label || '');
        if (label.includes('подзаголовок') || label.includes('podzagolovok')) {
            var value = asString(meta.value);
            if (value)
                return value;
        }
    }
    for (var _b = 0, _c = Object.keys(block.entity || {}); _b < _c.length; _b++) {
        var key = _c[_b];
        if (/podzagolovok/i.test(key)) {
            var value = entityValue(block, key);
            if (value)
                return value;
        }
    }
    return '';
};
var formatHours = function (raw) {
    var text = asString(raw).trim();
    if (!text)
        return '';
    if (/час/i.test(text))
        return text;
    return "".concat(text, " \u0447\u0430\u0441\u043E\u0432");
};
var mapCourses = function (block) {
    return collectionItems(block).map(function (item, index) {
        var programma = asString(field(item, 'programma'));
        return {
            title: asString(field(item, 'nazvanie')),
            duration: formatHours(field(item, 'chasy')),
            price: asString(field(item, 'tsena')),
            description: asString(field(item, 'opisanie')),
            tags: [],
            color: (index % 2 === 0 ? 'blue' : 'indigo'),
            programUrl: resolveMediaUrl(programma) || null,
        };
    });
};
var mapMotives = function (block) {
    return collectionItems(block).map(function (item, index) { return ({
        title: asString(field(item, 'zagolovok')),
        text: asString(field(item, 'opisanie')),
        color: index % 2 === 0 ? 'purple' : 'blue',
        iconSrc: resolveMediaUrl(asString(field(item, 'svg'))) || undefined,
    }); });
};
var mapFormat = function (block) {
    var textVariantToggle = 0;
    return collectionItems(block).map(function (item) {
        var title = asString(field(item, 'zagolovok'));
        var text = asString(field(item, 'opisanie'));
        var foto = resolveMediaUrl(asString(field(item, 'foto')));
        if (foto) {
            return {
                src: foto,
                variant: 'photo',
                title: title || undefined,
                text: text || undefined,
            };
        }
        if (!title && !text) {
            return {};
        }
        var variant = textVariantToggle % 2 === 0 ? 'blue' : 'green';
        textVariantToggle += 1;
        return { title: title, text: text, variant: variant };
    });
};
var mapFeedback = function (block) {
    return collectionItems(block).map(function (item) {
        var name = asString(field(item, 'fio'));
        var description = asString(field(item, 'opisanie'));
        var text = asString(field(item, 'otzyv'));
        var videoSrc = resolveMediaUrl(asString(field(item, 'video_otzyv')));
        var poster = resolveMediaUrl(asString(field(item, 'prevyu_video')));
        if (videoSrc) {
            return {
                variant: 'video',
                name: name,
                description: description,
                text: text,
                videoSrc: videoSrc,
                poster: poster || undefined,
            };
        }
        return { name: name, description: description, text: text };
    });
};
var mapTeachers = function (block) {
    return collectionItems(block).map(function (item) { return ({
        name: asString(field(item, 'fio')),
        description: asString(field(item, 'opisanie')),
        experienceLabel: asString(field(item, 'opyt')),
        src: resolveMediaUrl(asString(field(item, 'foto'))),
    }); });
};
var mapQuestions = function (block) {
    return collectionItems(block).map(function (item) { return ({
        title: asString(field(item, 'vopros')),
        text: asString(field(item, 'otvet')),
    }); });
};
var mapHeroBanner = function (block) {
    var fields = singletonFields(block);
    if (!Object.keys(fields).length)
        return null;
    return {
        title: asString(fields.zagolovok),
        subtitle: asString(fields.podzagolovok),
        primaryButtonText: asString(fields.knopka_1) || 'Получить консультацию',
        secondaryButtonText: asString(fields.knopka_2) || 'Выбрать курс',
        backgroundImage: resolveMediaUrl(asString(fields.fon)),
    };
};
var mapConsultationBanner = function (block) {
    var fields = singletonFields(block);
    if (!Object.keys(fields).length)
        return null;
    return {
        title: asString(fields.zagolovok),
        subtitle: asString(fields.podzagolovok),
        buttonText: asString(fields.knopka) || 'Получить консультацию',
        image: resolveMediaUrl(asString(fields.foto)),
    };
};
var mapBlockToSection = function (slug, block) {
    var kind = SLUG_TO_KIND[slug];
    if (!kind)
        return null;
    var heading = {
        title: sectionTitle(block),
        subtitle: sectionSubtitle(block),
        navLabel: asString(block.label) || sectionTitle(block) || slug,
    };
    var base = __assign({ slug: slug }, heading);
    switch (kind) {
        case 'courses':
            return __assign(__assign({}, base), { kind: kind, items: mapCourses(block) });
        case 'motives':
            return __assign(__assign({}, base), { kind: kind, items: mapMotives(block) });
        case 'format':
            return __assign(__assign({}, base), { kind: kind, items: mapFormat(block) });
        case 'feedback':
            return __assign(__assign({}, base), { kind: kind, items: mapFeedback(block) });
        case 'teachers':
            return __assign(__assign({}, base), { kind: kind, items: mapTeachers(block) });
        case 'questions':
            return __assign(__assign({}, base), { kind: kind, items: mapQuestions(block) });
        default:
            return null;
    }
};
export var emptySiteContent = function () { return ({
    heroBanner: null,
    consultationBanner: null,
    sections: [],
}); };
/** Порядок секций = порядок ключей в bootstrap.content */
export var mapBootstrapContent = function (data) {
    var content = (data === null || data === void 0 ? void 0 : data.content) || {};
    var sections = [];
    var heroBanner = mapHeroBanner(content[HERO_BANNER_SLUG]);
    var consultationBanner = mapConsultationBanner(content[CONSULTATION_BANNER_SLUG]);
    for (var _i = 0, _a = Object.keys(content); _i < _a.length; _i++) {
        var slug = _a[_i];
        if (slug === HERO_BANNER_SLUG || slug === CONSULTATION_BANNER_SLUG)
            continue;
        var section = mapBlockToSection(slug, content[slug]);
        if (section)
            sections.push(section);
    }
    return { heroBanner: heroBanner, consultationBanner: consultationBanner, sections: sections };
};
export var sectionsToNavItems = function (sections) {
    return sections
        .filter(function (section) { return section.kind !== 'questions'; })
        .map(function (section) { return ({
        id: section.slug,
        label: section.navLabel,
    }); });
};
